import { ServiceState } from '../../rz-status_models';
import React, { useState, useEffect, ReactNode } from 'react';
import StateIcon from './StateIcon';

export default function({data, children}:{data?: Record<ServiceState, number>, children?: React.FC | ReactNode }) {
  const [percentage, setPercentage] = useState(0);
  const [isExpanded, setExpanded] = useState(false);
  
  useEffect(() => {
    if(data != null) {
      const total = Object.values(data).reduce((sum, value) => sum + value, 0);
      setPercentage(data[0] / total * 100)
    }
  }, [data]);

  const Count = ({i}: {i: number}) => <span className="count">{data[i]}</span>


  if(data == null) {
    if(children != null) {
      return <div id="bar" className="block block-light">{children}</div>
    }
    return <div></div>
  }
  return <button id="bar" className={"block block-light collapsible" + (isExpanded ? " open" : "")} onClick={() => setExpanded(!isExpanded)} aria-controls="statecounters" aria-expanded={isExpanded ? "true" : "false"} aria-label="Anzahl der Störungen anzeigen">
    <div id="topcontainer">
      <div className="headline">
        <h2><span className="icon indicator"/>Aktuell verfügbar</h2>
        <span className="counter">
          <span className="icon state_ok"></span> 
          {data[0]} von {Object.entries(data).reduce((acc, [key, value]) => acc + value, 0)}
        </span>
      </div>
      <div className="progress-container">
        <div className="progress-fill" style=/>
      </div>
    </div>
    <div id="severicon"></div>
    <ul id="statecounters" className="collapsible-content">
      <li><StateIcon state={1}/> Wartung <Count i={1}/></li>
      <li><StateIcon state={2}/> Eingeschränkt <Count i={2}/></li>
      <li><StateIcon state={3}/> Nicht verfügbar <Count i={3}/></li>
    </ul>
  </button>
}